import { render, staticRenderFns } from "./AddLevelNotes.vue?vue&type=template&id=461f8e71&scoped=true&"
import script from "./AddLevelNotes.vue?vue&type=script&lang=js&"
export * from "./AddLevelNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461f8e71",
  null
  
)

export default component.exports